import React from 'react';
import classNames from 'classnames';

export const HorizontalDivider = ({ className }: { className?: string }) => (
  <div className={classNames('h-px w-full bg-gray-300', className)} />
);
